// chat.selectors — похідні значення (derived state).

export function buildMessagesWithTyping(messages, loading) {
  if (!loading) return messages;
  return [...messages, { role: "assistant", typing: true }];
}

export function buildCartItems(cart) {
  return Object.values(cart || {});
}

export function buildCartSummary(cartItems) {
  const itemsCount = cartItems.reduce((s, it) => s + (it.qty || 0), 0);
  const total = cartItems.reduce((s, it) => s + (it.price || 0) * (it.qty || 0), 0);
  return { itemsCount, total };
}
